import { FormValues } from '../types/FormTypes';

export interface ApiFormData {
  [key: string]: string | number | null;
}

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://members.mira-training.com';

// Log the API URL being used for debugging
console.log('apiService.ts: process.env.REACT_APP_API_URL =', process.env.REACT_APP_API_URL);
console.log('apiService.ts: API_BASE_URL =', API_BASE_URL);

// Backend will handle field mapping from field IDs to database columns

export const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      // Remove the data URL prefix (e.g., "data:image/jpeg;base64,")
      const base64 = result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const submitFormData = async (formValues: FormValues): Promise<void> => {
  try {
    console.log('=== FRONTEND FORM SUBMISSION ===');
    console.log('Form values:', formValues);
    console.log('Form keys:', Object.keys(formValues));

    // Create FormData for multipart/form-data submission (required for file uploads)
    const formData = new FormData();

    // Add form fields directly with their original field IDs (backend will handle mapping)
    for (const [key, value] of Object.entries(formValues)) {
      console.log(`Processing field: ${key} = ${value}`);
      
      if (value instanceof File) {
        console.log(`Adding file: ${key} - ${value.name} (${value.size} bytes)`);
        formData.append(key, value);
      } else if (value !== null && value !== undefined && value !== '') {
        console.log(`Adding field: ${key} = ${value}`);
        formData.append(key, String(value));
      }
    }

    // Debug: Show what's being sent
    console.log('FormData entries:');
    const entries = Array.from(formData.entries());
    entries.forEach(([key, value]) => {
      console.log(`  ${key}: ${value instanceof File ? `File(${value.name})` : value}`);
    });

    const response = await fetch(`${API_BASE_URL}/api/new_card`, {
      method: 'POST',
      // Don't set Content-Type header - let browser set it with boundary for multipart/form-data
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('API response error:', errorText);
      throw new Error(`API request failed with status ${response.status}: ${errorText}`);
    }

    const result = await response.json();
    console.log('Form submission successful:', result);
  } catch (error) {
    console.error('Form submission error:', error);
    throw error;
  }
};